export enum AgentRecommendationExperimentArea {
  Bern = 'BE',
  Zurich = 'ZH',
}

type PostalCodeRange = readonly [number, number];

// Source: swisstopo official directory of towns and cities, release 2026-04-01.
export const AGENT_RECOMMENDATION_EXPERIMENT_POSTAL_CODE_RANGES: Record<
  AgentRecommendationExperimentArea,
  readonly PostalCodeRange[]
> = {
  [AgentRecommendationExperimentArea.Bern]: [
    [1657, 1657],
    [1738, 1738],
    [1797, 1797],
    [2333, 2333],
    [2345, 2345],
    [2502, 2505],
    [2512, 2518],
    [2520, 2520],
    [2523, 2523],
    [2525, 2525],
    [2532, 2538],
    [2542, 2543],
    [2552, 2558],
    [2560, 2560],
    [2562, 2565],
    [2572, 2572],
    [2575, 2577],
    [2603, 2608],
    [2610, 2610],
    [2612, 2613],
    [2615, 2616],
    [2710, 2710],
    [2712, 2713],
    [2715, 2717],
    [2720, 2720],
    [2722, 2723],
    [2732, 2733],
    [2735, 2736],
    [2738, 2738],
    [2740, 2740],
    [2742, 2748],
    [2762, 2762],
    [2827, 2827],
    [3004, 3008],
    [3010, 3015],
    [3018, 3020],
    [3027, 3027],
    [3032, 3038],
    [3042, 3049],
    [3052, 3054],
    [3063, 3063],
    [3065, 3068],
    [3072, 3078],
    [3082, 3084],
    [3086, 3089],
    [3095, 3099],
    [3110, 3116],
    [3122, 3128],
    [3132, 3132],
    [3144, 3145],
    [3147, 3148],
    [3150, 3150],
    [3152, 3159],
    [3172, 3174],
    [3176, 3177],
    [3179, 3179],
    [3183, 3183],
    [3202, 3208],
    [3210, 3210],
    [3225, 3226],
    [3232, 3238],
    [3250, 3252],
    [3254, 3257],
    [3262, 3264],
    [3266, 3268],
    [3270, 3274],
    [3282, 3283],
    [3292, 3298],
    [3302, 3303],
    [3305, 3306],
    [3308, 3309],
    [3312, 3315],
    [3317, 3317],
    [3322, 3326],
    [3360, 3360],
    [3362, 3363],
    [3365, 3368],
    [3372, 3377],
    [3380, 3380],
    [3400, 3400],
    [3412, 3419],
    [3421, 3429],
    [3432, 3439],
    [3452, 3457],
    [3462, 3465],
    [3472, 3476],
    [3503, 3504],
    [3506, 3508],
    [3510, 3510],
    [3512, 3513],
    [3531, 3538],
    [3543, 3543],
    [3550, 3553],
    [3555, 3557],
    [3600, 3600],
    [3603, 3604],
    [3608, 3608],
    [3612, 3619],
    [3622, 3629],
    [3631, 3636],
    [3638, 3638],
    [3645, 3647],
    [3652, 3658],
    [3661, 3665],
    [3671, 3674],
    [3700, 3700],
    [3702, 3707],
    [3711, 3711],
    [3713, 3718],
    [3722, 3725],
    [3752, 3758],
    [3762, 3766],
    [3770, 3773],
    [3775, 3778],
    [3780, 3785],
    [3792, 3792],
    [3800, 3801],
    [3803, 3807],
    [3812, 3816],
    [3818, 3818],
    [3822, 3826],
    [3852, 3858],
    [3860, 3860],
    [3862, 3864],
    [4536, 4539],
    [4556, 4556],
    [4564, 4564],
    [4573, 4573],
    [4704, 4704],
    [4716, 4716],
    [4900, 4900],
    [4911, 4914],
    [4916, 4917],
    [4919, 4919],
    [4922, 4924],
    [4932, 4938],
    [4942, 4944],
    [4950, 4950],
    [4952, 4955],
    [6083, 6086],
    [6146, 6147],
    [6197, 6197],
  ],
  [AgentRecommendationExperimentArea.Zurich]: [
    [5462, 5462],
    [6340, 6340],
    [8001, 8006],
    [8008, 8008],
    [8032, 8032],
    [8037, 8038],
    [8041, 8041],
    [8044, 8053],
    [8055, 8055],
    [8057, 8057],
    [8064, 8064],
    [8102, 8108],
    [8112, 8115],
    [8117, 8118],
    [8121, 8127],
    [8132, 8136],
    [8142, 8143],
    [8152, 8158],
    [8162, 8162],
    [8164, 8166],
    [8172, 8175],
    [8180, 8182],
    [8184, 8185],
    [8187, 8187],
    [8192, 8197],
    [8212, 8212],
    [8245, 8248],
    [8302, 8312],
    [8314, 8315],
    [8317, 8317],
    [8320, 8320],
    [8322, 8322],
    [8330, 8332],
    [8335, 8335],
    [8340, 8340],
    [8342, 8342],
    [8344, 8345],
    [8352, 8355],
    [8363, 8363],
    [8400, 8400],
    [8404, 8406],
    [8408, 8409],
    [8412, 8416],
    [8418, 8418],
    [8421, 8422],
    [8424, 8428],
    [8442, 8442],
    [8444, 8444],
    [8447, 8447],
    [8450, 8453],
    [8457, 8468],
    [8471, 8472],
    [8474, 8479],
    [8482, 8484],
    [8486, 8489],
    [8492, 8500],
    [8523, 8523],
    [8525, 8525],
    [8542, 8546],
    [8548, 8548],
    [8600, 8600],
    [8602, 8608],
    [8610, 8610],
    [8614, 8618],
    [8620, 8620],
    [8623, 8627],
    [8630, 8630],
    [8632, 8637],
    [8700, 8700],
    [8702, 8704],
    [8706, 8708],
    [8712, 8714],
    [8800, 8800],
    [8802, 8805],
    [8810, 8810],
    [8815, 8816],
    [8820, 8820],
    [8824, 8825],
    [8833, 8833],
    [8902, 8904],
    [8906, 8915],
    [8925, 8926],
    [8932, 8934],
    [8942, 8942],
    [8951, 8955],
  ],
};

const EXPERIMENT_POSTAL_CODE_RANGES = [
  ...AGENT_RECOMMENDATION_EXPERIMENT_POSTAL_CODE_RANGES[AgentRecommendationExperimentArea.Bern],
  ...AGENT_RECOMMENDATION_EXPERIMENT_POSTAL_CODE_RANGES[AgentRecommendationExperimentArea.Zurich],
];

const normalizePostalCode = (postalCode: unknown): number | null => {
  if (typeof postalCode !== 'string' && typeof postalCode !== 'number') {
    return null;
  }

  const normalizedPostalCode = String(postalCode).trim();
  return /^\d{4}$/.test(normalizedPostalCode) ? Number(normalizedPostalCode) : null;
};

export const isPostalCodeInExperimentRegion = (postalCode: unknown): boolean => {
  const normalizedPostalCode = normalizePostalCode(postalCode);
  if (!normalizedPostalCode) {
    return false;
  }

  return EXPERIMENT_POSTAL_CODE_RANGES.some(
    ([from, to]) => normalizedPostalCode >= from && normalizedPostalCode <= to,
  );
};
